<script setup lang="ts">
import type { UIFullScreenVideoProps } from './UIFullScreenVideo.props'

defineProps<UIFullScreenVideoProps>()

const { isIos } = useDevice()

const togglePause = async (event: MouseEvent) => {
  const video = event.currentTarget as HTMLVideoElement
  try {
    if (video.paused) {
      await video.play()
    } else {
      video.pause()
    }
  } catch (error) {
    console.log(error)
  }
}
</script>
<template>
  <div class="flex h-dvh w-screen items-center justify-center">
    <div
      class="relative inline-flex w-screen items-center justify-center overflow-hidden"
      :class="title ? 'max-h-[90vh]' : 'max-h-[100vh]'"
    >
      <video
        :muted="true"
        :loop="true"
        :autoplay="true"
        controlsList="nofullscreen nodownload"
        webkit-playsinline
        playsinline
        :poster="posterVideo(src)"
        class="max-h-full"
        @click="togglePause"
      >
        <source
          v-if="!isIos"
          :src="optimizeVideo(src, 'best', undefined, 'webm')"
          type="video/webm"
        />
        <source :src="optimizeVideo(src, 'best')" type="video/mp4" />
      </video>
    </div>
    <span
      v-if="title"
      class="flex h-[10vh] items-center justify-end px-4 lg:px-0"
    >
      {{ title }}
    </span>
  </div>
</template>
